import { frontendURL } from 'dashboard/helper/URLHelper';

// Todas as telas do Kanban são LAZY (carregadas sob demanda por rota) — assim as
// ~20 telas grandes (board, flows, email/GrapesJS, projetos, chat) NÃO entram no
// bundle inicial do dashboard. Quem só usa a caixa de entrada não baixa nada disso.
const perms = ['administrator', 'agent', 'custom_role'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_home',
    meta: { permissions: perms },
    component: () => import('./KanbanBoard.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/kanban/funnels'),
    name: 'kanban_funnels',
    meta: { permissions: perms },
    component: () => import('./KanbanFunnels.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/kanban/cards/:cardId'),
    name: 'kanban_card_detail',
    meta: { permissions: perms },
    component: () => import('./KanbanCardDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows'),
    name: 'kanban_flows',
    meta: { permissions: perms },
    component: () => import('./KanbanFlows.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/crm-reports'),
    name: 'kanban_reports',
    meta: { permissions: perms },
    component: () => import('./KanbanReports.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/calls-report'),
    name: 'kanban_calls',
    meta: { permissions: perms },
    component: () => import('./KanbanCalls.vue'),
  },
  {
    // legado: o painel de Ligações nativo do Chatwoot assumiu o /calls. Mantido
    // em /calls-legacy só para links antigos; fora do menu.
    path: frontendURL('accounts/:accountId/calls-legacy'),
    name: 'kanban_calls_center',
    meta: { permissions: perms },
    component: () => import('./KanbanCallsCenter.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId/history/:executionId'),
    name: 'kanban_flow_execution_detail',
    meta: { permissions: perms },
    component: () => import('./KanbanFlowExecutionDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId/history'),
    name: 'kanban_flow_history',
    meta: { permissions: perms },
    component: () => import('./KanbanFlowHistory.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId'),
    name: 'kanban_flow_builder',
    meta: { permissions: perms },
    component: () => import('./KanbanFlowBuilder.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/projects'),
    name: 'kanban_projects',
    meta: { permissions: perms },
    component: () => import('./KanbanProjects.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/projects/:projectId'),
    name: 'kanban_project_detail',
    meta: { permissions: perms },
    component: () => import('./KanbanProjectDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/appointments'),
    name: 'kanban_appointments',
    meta: { permissions: perms },
    component: () => import('./KanbanAppointments.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/disparador'),
    name: 'kanban_campaigns',
    meta: { permissions: perms },
    component: () => import('./KanbanCampaigns.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/disparador/new'),
    name: 'kanban_campaign_wizard',
    meta: { permissions: perms },
    component: () => import('./KanbanCampaignWizard.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/disparador/:campaignId'),
    name: 'kanban_campaign_detail',
    meta: { permissions: perms },
    component: () => import('./KanbanCampaignDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email'),
    name: 'kanban_email',
    meta: { permissions: perms },
    component: () => import('./KanbanEmail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/new'),
    name: 'kanban_email_wizard',
    meta: { permissions: perms },
    component: () => import('./KanbanEmailWizard.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/templates/new'),
    name: 'kanban_email_template_new',
    meta: { permissions: perms },
    component: () => import('./KanbanEmailTemplateEditor.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/templates/:templateId'),
    name: 'kanban_email_template',
    meta: { permissions: perms },
    component: () => import('./KanbanEmailTemplateEditor.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/:campaignId'),
    name: 'kanban_email_report',
    meta: { permissions: perms },
    component: () => import('./KanbanEmailReport.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/internal-chats'),
    name: 'kanban_internal_chats',
    meta: { permissions: perms },
    component: () => import('./KanbanChats.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/connections'),
    name: 'kanban_connections',
    meta: { permissions: ['administrator', 'custom_role'] },
    component: () => import('./KanbanConnections.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/synapse'),
    name: 'synapse',
    meta: { permissions: perms },
    component: () => import('../synapse/SynapseView.vue'),
  },
];
